// getIsMatchedByMediaQuery.js
'use strict';
import { getIsInBrowserMainThread } from '../resource/getJsEnvironment.js';
import { breakpoint } from '../style/variables.js';

const isClient = getIsInBrowserMainThread();

export const Key = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

/**
 * Get is matched by media query
 * @param {Key} {key} - key.
 */
const getIsMatchedByMediaQuery = ({ key }) => {
  if (!isClient) {
    return false;
  }
  const screenWidth = window?.innerWidth;
  switch (key) {
    case Key.MOBILE: {
      return screenWidth <= breakpoint.mobile;
    }
    case Key.DESKTOP: {
      return screenWidth > breakpoint.tablet;
    }
  }
};

export default getIsMatchedByMediaQuery;
